<template>
  <v-dialog v-model="intDialogVisible" max-width="600px" class="addValueModal addToAList addComment">
    <v-card>
      <v-card-title>
        <h3 class="primary--text formName">Assign to a criteria group</h3>
        <span @click="close" class="close">X</span>
      </v-card-title>
      <v-card-text>
        <div class="row addListOption">
          <strong>To an existing group</strong>
          <div class="flexIt">
            <v-autocomplete v-model="existingList" :items="available_list"  item-title="name" item-value="_id.$oid" ></v-autocomplete>

            <button type="button" class="smallModalBtn" :disabled="!existingList" name="button" @click="addToExisting">Add to an existing group</button>

          </div>
        </div>
        <div class="row addListOption ">
          <strong>To a new group</strong>
          <div class="flexIt">
            <input type="text" placeholder="Name of the list" class="listInput" v-model="newList">
            <button type="button" class="smallModalBtn" :disabled="newList == ''" name="button" @click="addToNewList">Add to a new group</button>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/tools/api';
export default {
  props: {
    dialogVisible: Boolean,
    searchfield: String
  },
  data () {
    return{
      customerValue:'',
      returnedCustomerValue:'',
      available_list : [],
      existingList: '',
      newList:''
    }
  },
  methods:{
    submit(){
      this.returnedCustomerValue = this.customerValue;
      this.customerValue = "";
       this.$emit('newValueIsProposed',this.returnedCustomerValue)
    },
    close(){
        this.$emit('close',false)
    },
    addToExisting(){
      this.$emit('toExisting',this.existingList);
    },
    addToNewList(){
      this.$emit('toNew',this.newList);
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
          console.log(this.searchfield);
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    }
  },
  watch: {
    dialogVisible: function(){
      this.customerValue = "";
      if(this.dialogVisible == true){
        api.get(process.env.VUE_APP_API_URL+"/restrict/global_criteria_groups").then( (r) => {
          console.log("IS ASSESS");
          console.log(r.data);
          this.available_list = r.data;
        });
      }
    }
  }

}
</script>

<style media="screen" scoped>
  .addValueModal .v-card{
    padding:10px;
  }
  .addValueModal .v-field__outline{
    display:none;
  }
  /* .formName{
    text-align: left;
    font-size: 21px;
    line-height: 25px;
    color: #3783C5;
  }
  .addValueModal button{
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 7px 18.5px;
    color:#3783C5;
    margin: 5px;
  }

    .addValueModal button.addValue{
      border: 1px solid #3783C5;

      background:#3783C5;
      color:#fff;
    }

    .addValueInput input{
      border: 1px solid #DDDDDD;
    }
  .addComment textarea{
    width: 100%;
margin: 0;
border: 1px solid #DDDDDD;
mask-image: none !important;
  }
  .v-card-title{
    white-space: normal !important;
  } */

.close{
  position: absolute;
    right: 0;
    top: 0;
    padding: 5px 15px;
    background: #4C81C0;
    color: #FFF;
    cursor: pointer;
    font-size: 14px;
    line-height: 25px;
}
.formName{
  padding-right:30px;
}
.flexIt{
  display:flex;
  width:100%;
  flex-wrap: wrap;
  gap: 20px;
  margin-top:10px;


  flex-direction: column;
  align-content: flex-start;
  align-items: flex-start;
  align-self: flex-start;
}
.flexIt > div {
  display: flex;
  width: 100%;
}
  .addListOption:first-of-type{
    padding-bottom:20px;
    border-bottom:1px solid #CCC;
  }
    .addListOption:last-of-type{
          padding-bottom:20px;
              padding-top:20px;
    }

    .listInput,
    .listInput:focus,
    .listInput:focus-visible{
      border:none;
      border-bottom:1px solid #4C81C0;
      width:100%;
    }

    .smallModalBtn{
      background: #4C81C0;
      color: #fff !important;
      font-size:15px !important;
      padding: 5px 10px !important;
      border-radius: 50px;
    }

.smallModalBtn:disabled{
  opacity:0.7;
}
    .v-text-field .v-input__details{
      display:none;
    }

</style>

<style media="screen">
.addToAList .v-input__control{
  width:100%;
}
</style>
